import { render } from "./DistributorsProducts.vue?vue&type=template&id=4cfaf2ef"
import script from "./DistributorsProducts.vue?vue&type=script&lang=js"
export * from "./DistributorsProducts.vue?vue&type=script&lang=js"

import "./DistributorsProducts.vue?vue&type=style&index=0&id=4cfaf2ef&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__